import { NoteBody, NotePopover } from '@/components/ui/note-popover';

/**
 * 記録 1 件のメモを 1 行に畳んだ見出し。
 *
 * 訂正フォームは 1 マスに何件でも並ぶので、入力欄の中身を 1 件ずつ
 * 読み比べなくても「どの記録のメモか」が分かるようにここへ出す。
 * 全文はホバー / フォーカス / タップで開く。
 */
export function NotePreview({ note }: { note: string }) {
  return (
    <span className="flex min-w-0 flex-1 items-center gap-2">
      <span className="shrink-0 text-xs text-ink-faint">メモ</span>
      <NotePopover content={<NoteBody note={note} />} className="min-w-0 flex-1">
        <button
          type="button"
          aria-label="メモの全文を表示"
          className="block w-full truncate text-left text-xs text-ink-muted underline decoration-line-bold decoration-dotted underline-offset-2 hover:text-ink"
        >
          {note}
        </button>
      </NotePopover>
    </span>
  );
}
